export const API_SUCCESS_RESPONSE_TAG = "API_SUCCESS_RESPONSE_TAG";

export const DATA_FETCHING_STATUSES = {
  DATA_LOADING: "DATA_LOADING",
  DATA_LOADED: "DATA_LOADED",
};

export const LOCAL_STROAGE_KEYS = {
  USER: "USER",
  ACCESS_TOKEN: "ACCESS_TOKEN",
  REFRESH_ACCESS_TOKEN: "REFRESH_ACCESS_TOKEN",
};

export const LOCAL_STROAGE_USER_GET_KEY = `persist:${LOCAL_STROAGE_KEYS.USER}`;

export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; // No /v1 in env
export const BACKEND_BASE_URL = API_BASE_URL; // Same as API_BASE_URL now
export const ENDPOINTS = {
  LOGIN: "/v1/auth/admin/login",
  LOGOUT: "/v1/auth/admin/logout",
  SIGN_UP: "/v1/auth/register-admin",
  REFRESH_TOKEN: "/v1/auth/refresh-tokens",
  FORGOT_PASSWORD: "/v1/auth/forgot-password",
  RESET_PASSWORD: "/v1/auth/reset-password",
  VERIFY_EMAIL: "/v1/auth/verify-email",
  SEND_EMAIL_VERIFICATION: "/v1/auth/send-verification-email",
  USERS: "/v1/users",
  UPDATE_PROFILE_PICTURE: "/v1/users/upload-profile-picture",
  REWARDS: "/v1/rewards",
  LEADERBOARD: "/v1/leaderboard",
  SEND_INVITATION: "/v1/auth/send-admin-invite",
  CHATS: "/v1/chats",
  PLAYER_GAME_HISTORY: "/v1/user-stats",
  GAME_ENTRY_FEE: "/v1/global-settings",
  NOTIFICATIONS: "/v1/admin-notifications",
  PUSH_NOTIFICATIONS: "/v1/admin-notifications/broadcast",
  UPLOAD_IMAGE: "/v1/upload-image",
  BACKGROUND_IMAGE: "/v1/background-image",
  ACTIVE_BACKGROUND_IMAGE: "/v1/background-image/active",
};

export const REWARD_TYPES_MAP = {
  // LOGIN_ACORNS: "LOGIN_ACORNS",
  // LOGIN_GOLDEN_ACORNS: "LOGIN_GOLDEN_ACORNS",
  GIFT_CARD: "LEADERBOARD_GIFT_CARD",
  BURGER: "LEADERBOARD_ACORNS",
  CHEESE_BURGER: "LEADERBOARD_GOLDEN_ACORNS",
};

export const REWARD_TYPES_REVERSE_MAP = Object.entries(REWARD_TYPES_MAP).reduce(
  (acc, current) => {
    return {
      ...acc,
      [current[1]]: current[0],
    };
  },
  {}
);

export const REWARD_TYPES = Object.values(REWARD_TYPES_MAP);

export const SOCKET_EVENTS = {
  SEND_MESSAGE: "sendMessageToUser",
  SEND_MESSAGE_TO_ALL: "sendMessageToAllUsers",
  RECEIVE_MESSAGE: "receiveMessage",
  RECEIVE_NOTIFICATIONS: "sendNotifications",
  MARK_CHAT_AS_READ: "markChatsAsReadFromAdmin",
};

export const ROLES = {
  SUPER_ADMIN: "superAdmin",
  ADMIN: "admin",
  PLAYER: "player",
};
// export const URLS = Object.keys(ENDPOINTS).reduce((acc, current) => {
//   acc[current] = API_BASE_URL + ENDPOINTS[current];
//   return acc;
// }, {});
